import {
  ETypeMainHead,
  CTypeCardView,
  DTypeBreadCrumb,
  colors,
  FullWidthTwinButton,
  call,
  GOI_WEB_URL,
  ATypeNationalMeritSummary,
  FitWidthSmallButton,
  ATypeNationalMeritDescription,
  customEvent,
} from "goi_common";
import { GetStaticPaths, GetStaticProps } from "next";

import React from "react";
import { ParlorDetailProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";
import facilities from "goi_common/src/constants/facilities_detail.json";

const { regionColor, targetSidos } = parlorRegion;



export const getStaticPaths: GetStaticPaths = async () => {
  const paths = facilities
    .filter((f) => targetSidos.includes(f.sido) && f.is_public)
    .map((f) => ({
      params: {
        companyname: f.companyname,
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const companyname = params?.companyname;
  let p_facility;
  let district;
  let name = "";
  let description = "";

  if (companyname) {
    p_facility = facilities.find((f) => f.companyname === companyname);

    if (p_facility) {
      name = p_facility.companyname;

      district = p_facility.address.slice(0, 2);
      if (p_facility.address.split(" ")[0].length == 4)
        district = p_facility.address[0] + p_facility.address[2];

      description = `수도권 국가유공자가 공설 장지(${p_facility.companyname})에 우선 안치되기 위해선 국가유공자임을 증명하는 국가유공자증이 필요합니다. 국가유공자증은 주소지 관할 보훈청 보상과에서 발급 가능하며, 자세한 혜택은 상담을 통해 안내받을 수 있습니다.`;
    }
  }

  return {
    props: {
      defaultPFacility: p_facility,
      pageDescription: description,
      pageKeywords: `${p_facility?.companyname}, ${p_facility?.companyname} 국가유공자, ${district} 국가유공자 장례, ${district} 국가유공자 화장 비용, ${district} 국가유공자 장례 혜택`,
      pageOgTitle: `${p_facility?.companyname} 국가유공자를 위한 공설 장지 비용 안내 | 서울경기인천장례정보포털`,
      pageOgDescription: description,
      pageOgImage: p_facility?.images[0].url || "",
      hasError: !p_facility,
    },
  };
};

export default function companyname({
  defaultPFacility,
  pageOgTitle,
}: {
  defaultPFacility: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionPFacilities = facilities.filter((p) =>
    targetSidos.includes(String(p.sido)) && p.is_public
  );
  
  const carouselItems = regionPFacilities.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.metropolitan-funeral.co.kr/veterans/jangji/${res.companyname}/`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionPFacilities.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <Stack>
      <Head>
        <title>{pageOgTitle}</title>
        {regionPFacilities.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>

      <DTypeBreadCrumb
        mainColor={regionColor}
        firstItem={{
          text: `수도권 국가유공자 장례114`,
          href: `/veterans/`,
          event: {
            domain: "metro",
            path: "veterans_facility",
            trigger_and_target: "br_crumb_veterans",
          },
        }}
        goiHomeEvent={{
          domain: "metro",
          path: "veterans_facility",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />
      <ETypeMainHead
        mainColor={regionColor}
        defaultParlor={defaultPFacility}
        title={`${defaultPFacility.companyname}`}
        managed_type={defaultPFacility.managed_type}
        address={defaultPFacility.address}
      />

      <Stack padding="20px" gap="12px">
        <Box className="subtitle_14_b" textAlign="center">
          상담을 통해 자세한 국가 유공자 장례 혜택을 안내드립니다.
        </Box>
        <FullWidthTwinButton
          firstBtn={{
            isGoiCall: true,
            text: "상담하기",
            onClick: () => {
              call("1666-9784");
              customEvent({
                domain: "metro",
                path: "veterans_facility",
                trigger_and_target: "goi_call",
              });
            },
          }}
          secondBtn={{
            text: "비용 알아보기",
            href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
            onClick: () => {
              customEvent({
                domain: "metro",
                path: "veterans_facility",
                trigger_and_target: "uv_mth_req",
              });
            },
          }}
          backgroundColor={regionColor.c400}
        />
        <ATypeNationalMeritSummary mainColor={regionColor} />
        <Stack
          flexDirection="row"
          justifyContent="space-between"
          padding="16px 20px"
          gap="4px"
          width="100%"
          alignItems="center"
        >
          <Stack flexDirection="row" gap="8px">
            <Box className="subtitle_14_sb" style={{ color: regionColor.c300 }}>
              관내 국가유공자
            </Box>
            <Box className="subtitle_14_b">화장 시설 무료</Box>
          </Stack>
          <FitWidthSmallButton
            backgroundColor={regionColor.c300}
            text="문의하기"
            href={GOI_WEB_URL + "/match/request/?utm_source=dogsound"}
            event={{
              domain: "metro",
              path: "veterans_facility",
              trigger_and_target: "uv_mth_req_btom",
            }}
          />
        </Stack>
        <ATypeNationalMeritDescription />
      </Stack>

      <Box padding="0 20px">
        <Box
          width="100%"
          height="1px"
          style={{ background: colors.gray900 }}
          margin="0 0 20px"
          padding="0 20px"
        />
      </Box>

      <Stack padding="0px 20px" marginBottom="40px" gap="8px">
        <h3 className="subtitle_18_b" style={{ textAlign: "center" }}>
          서울 · 경기 · 인천 지역 장지
        </h3>
        {regionPFacilities.map((res) => (
          <CTypeCardView
            sigungu={res.sigungu}
            mainColor={regionColor}
            key={res.companyname}
            name={res.companyname}
            href={`/veterans/jangji/${res.companyname}/`}
            sido={String(res.sido)}
            descriptions={["국가유공자 우선 안치"]}
            imgSrc={res.images[0]?.url ? res.images[0].url : ""}
            event={{
              domain: "metro",
              path: "veterans_facility",
              trigger_and_target: "uv_facility_detail",
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
